import React from 'react';
import { TimerIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useOfferTimer';
type CountdownProps = {
  dark?: boolean;
};
export function Countdown({
  dark = false
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    label: 'Hours',
    value: hours
  }, {
    label: 'Minutes',
    value: minutes
  }, {
    label: 'Seconds',
    value: seconds
  }];
  return <div role="timer" aria-live="off" className={`rounded-2xl border p-4 ${dark ? 'border-white/15 bg-white/5' : 'border-alert/20 bg-alert/5'}`} data-id="element-2" data-mp="3c0uqpj1bf8d6">
      <p className={`flex items-center justify-center gap-2 text-center text-sm font-bold uppercase tracking-wide ${dark ? 'text-white' : 'text-alert'}`} data-id="element-3" data-mp="323yf34g4e64e">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-4" data-mp="10cl8mayi7q68" />
        Promotional price ends in
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-5" data-mp="15b698bho4bv7">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-6" data-mp="y0n09ll1b38z" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-7" data-mp="xzln9bkgk6om">
              <span className="flex h-16 w-[4.5rem] items-center justify-center rounded-xl bg-alert font-display text-4xl font-black tabular-nums text-white shadow-[0_4px_0_0_#A61E2C] sm:h-[4.5rem] sm:w-20" data-id="element-8" data-mp="t2lh70nlz3xi">
                {String(u.value).padStart(2, '0')}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? 'text-white/60' : 'text-ink/55'}`} data-id="element-9" data-mp="f2aort6nhha8">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-3 font-display text-3xl font-black ${dark ? 'text-white/70' : 'text-alert'}`} data-id="element-10" data-mp="o3s59cnyzkzg">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}